import SignatoryGroupRepository from "../domain/data/SignatoryGroupRepository";
import SignatoryGroup from "../domain/entities/SignatoryGroup";
import User from "../domain/entities/User";
import AwsApiClient from "../presentation/hooks/AwsApiClient";
import URLUtils from "./URLUtils";

export default class APISignatoryGroupRepository
  implements SignatoryGroupRepository
{
  private client = new AwsApiClient();

  async getSignatoryGroups(user: User): Promise<SignatoryGroup[]> {
    try {
      const response = await this.client.get(
        `/api/signatoryGroup/${user.organization.id}/${user.id}`
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async saveSignatoryGroup(
    user: User,
    signatoryGroup: SignatoryGroup
  ): Promise<SignatoryGroup> {
    try {
      const response = await this.client.post(
        `/api/signatoryGroup`,
        signatoryGroup
      );
      return response;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async saveSignatoryGroupAsync(
    user: User,
    signatoryGroup: SignatoryGroup
  ): Promise<void> {
    try {
      this.client.post(`/api/signatoryGroup`, signatoryGroup);
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }

  async deleteSignatoryGroup(
    user: User,
    signatoryGroup: SignatoryGroup
  ): Promise<boolean> {
    try {
      const response = await this.client.delete(
        `/api/signatoryGroup/${user.organization.id}/${user.id}/${signatoryGroup.id}`,
        "none"
      );
      return true;
    } catch (error) {
      const message = `An error has occured: ${error}`;
      throw new Error(message);
    }
  }
}
